<template>
  <v-app>


    <v-main id="parent-civ">
      <router-view v-slot="{ Component }" :class="{ 'disable-scroll': false }">
        <Transition name="fade" mode="out-in">
          <component :is="Component" />
        </Transition>
      </router-view>
    </v-main>


  </v-app>
</template>

<script>

import { useMobile } from './composables/useMobile.js'
import { useMobileXs } from './composables/useMobileXs.js'

export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()

    return { isMobile, isMobileXs }
  },
  name: 'App',

  components: {

  },

  data: () => ({

  }),
  mounted() {

  },
  beforeDestroy() {

  },
  created() {

  },
  computed: {

  },
  methods: {

  },
  watch: {
    '$route': {
      handler: (to, from) => {
        document.title = to.meta.title || 'MuzE'
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
@use './views/css/styles.scss';

:root {
  --toastify-color-dark: black;
  --toastify-color-success: #1ff050;

}

.Toastify__toast {
  border: 1px solid white !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px!important;
}

.v-navigation-drawer__content {
  border: 1px solid black !important;
}

.overlay {
  position: relative;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  display: flex;
  justify-content: start;
  padding-left: 8px;
  align-items: center;
  opacity: 1;
  transition: opacity 0.3s ease;
  border-radius: 10px;
  border: 0px solid black;
  height: 36px;
}

.overlay-text {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  font-weight: bold !important;
}

.image-container2 {
  position: relative;
  border: 0px solid black;
  border-radius: 0px;
}


.image-container2:hover .overlay {
  opacity: 0;
  cursor: pointer;
  border: 1px solid white;
}

.loading-spinner {
  position: absolute;
  top: 41%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  background-color: transparent;
}

.loading-spinner2 {
  position: absolute;
  z-index: 2;
  background-color: transparent;
}

/* width */
::-webkit-scrollbar {
  width: 4px;
  background: transparent !important;
  -webkit-overflow-scrolling: auto !important;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent!important;
  border-radius: 10px;
}

.overlay-grey::-webkit-scrollbar-thumb {
  background: #2a2a2a !important;
  border-radius: 10px;
}

.overlay-grey {
  background-color: black !important;
  padding: 4px !important;
  margin: 3px !important;
  border: 1px solid white !important;
  //box-shadow: 0px 0px 0px 1px black !important;
  border-radius: 10px !important;
  overflow-y: scroll;
  flex-grow: 1;
  min-height: calc(100vh - 80px);
  scrollbar-color: transparent transparent;
  scrollbar-width: thin !important;
  scrollbar-gutter: stable !important;
}

.overlay-grey:hover {
  overflow-y: scroll;
  scrollbar-color: #2a2a2a transparent;
}



.errorBox {
  background-color: black !important;
  border: 1px solid #E34234 !important;
}

.okBox {
  background-color: black !important;
  border: 1px solid #1ff050 !important;

}

#bkgrdVideoFunc22 {
  background-color: transparent !important;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-height: 100vh !important;
  object-fit: cover;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.disable-scroll {
  overflow: hidden !important;
  /* Hide vertical scrollbar */
}

#app {
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
  font-family: "Darker Grotesque", sans-serif !important;
}

#body {
  background-color: transparent !important;
  text-rendering: optimizeLegibility !important;
}

#parent-civ {
  position: relative !important;
  background-color: black !important;
  padding-top: 0px !important;
  padding: 0 !important;
  margin: 0 !important;
}

.navigationStandard {
  background-color: transparent !important;
  position: fixed !important;
  top: 64px !important;
  left: 0px !important;
  max-width: 320px !important;
  min-height: 100vh !important;
  padding: 0 !important;
  margin: 0 !important;
  opacity: 1 !important;
  z-index: 100 !important;
  border-right: 0px solid black !important;

}

.navigationMobile {
  background-color: transparent !important;
  position: fixed !important;
  top: 64px !important;
  left: 0 !important;
  max-width: 320px !important;
  min-height: 100vh !important;
  padding: 0 !important;
  margin: 0 !important;
  opacity: 1 !important;
  z-index: 100 !important;
  border-right: 0px solid black !important;
}

.container-size-drawer {
  padding-right: 24px !important;
  padding-left: 24px !important;
  background-color: transparent !important;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.container-size {
  padding-right: 24px;
  padding-left: 24px;

  @media (min-width: 960px) {
    max-width: 1608px;
  }
}

.container-size-top {
  padding-right: 24px;
  padding-left: 24px;
  background-color: black !important;
  width: 100vw !important;
}


.menu-btn-close {
  color: white !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: bold !important;
  font-size: 18px !important;
  transition: none !important;
  margin-left: 10px !important;
  padding-left: 2px !important;
  margin-right: 10px !important;
  padding-right: 2px !important;
  background-color: transparent !important;
}

.menu-btn-close:hover {
  color: white !important;
  background-color: transparent !important;
  transition: none !important;
}

.menu-btn-close:hover .v-btn__overlay {
  background-color: transparent !important;
}

.icon-menu:hover .v-btn__overlay {
  background-color: transparent !important;
}

.menu-btn-close::before {
  content: "" !important;
  position: absolute !important;
  left: 5px !important;
  top: 34px !important;
  width: 85% !important;
  height: 1px !important;
  background-color: white !important;
  opacity: 0 !important;
}

.menu-btn-close:hover::before {
  opacity: 1 !important;
}




.title-expansion {
  background-color: black !important;
  color: white !important;
  padding: 0 !important;
  min-height: 0 !important;
}

.title-text {
  background-color: black !important;
  color: white !important;
}

.panel-expansion {
  background-color: black !important;
}

.v-expansion-panel-title__overlay {
  background-color: black !important;
}

.v-expansion-panel-title__icon {
  padding-right: 12px !important;
}

.icon-exp-sub {
  color: white !important;
  padding: 0 !important;
  margin: 0 !important;
  padding-right: 20px !important;
  padding-top: 14px !important;
  opacity: 1 !important;
}


.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease !important;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0 !important;
}

.text-head {
  font-size: 50px !important;
  line-height: 0.9 !important;
  font-weight: 500 !important;

  @media (min-width: 600px) {
    font-size: 64px !important;
    font-weight: 500 !important;
    line-height: 0.9 !important;
  }

  @media (min-width: 1280px) {
    font-size: 88px !important;
    font-weight: 500 !important;
    line-height: 0.9 !important;
  }

}

.fonts-head {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 40px !important;
  font-weight: 500 !important;
  color: white;
  word-spacing: normal !important;
  line-height: 1 !important;
  display: inline-block !important;

}

.fonts-desc {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 28px !important;
  font-weight: 500 !important;
  color: white;
  word-spacing: normal !important;
  line-height: 1 !important;
  display: inline-block !important;

  @media (min-width: 600px) {
    font-size: 32px !important;
  }

  @media (min-width: 1280px) {
    font-size: 36px !important;
  }
}

.fonts-desc2 {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 36px !important;
  font-weight: 500 !important;
  color: white;
  word-spacing: normal !important;
  line-height: 1 !important;
  display: inline-block !important;

  @media (min-width: 600px) {
    font-size: 38px !important;
  }

  @media (min-width: 1280px) {
    font-size: 42px !important;
  }
}

.fonts-desc3 {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 29px !important;
  font-weight: 500 !important;
  color: white;
  word-spacing: normal !important;
  line-height: 1 !important;
  display: inline-block !important;

  @media (min-width: 600px) {
    font-size: 31px !important;
  }

  @media (min-width: 1280px) {
    font-size: 35px !important;
  }
}

.fonts-desc4 {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 20px !important;
  font-weight: 500 !important;
  color: white;
  word-spacing: normal !important;
  line-height: 1 !important;
  display: inline-block !important;

  @media (min-width: 600px) {
    font-size: 26px !important;
  }

  @media (min-width: 1280px) {
    font-size: 30px !important;
  }
}

.fonts-desc5 {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 26px !important;
  font-weight: 500 !important;
  color: white;
  word-spacing: normal !important;
  line-height: 1 !important;
  display: inline-block !important;

  @media (min-width: 600px) {
    font-size: 26px !important;
  }

  @media (min-width: 1280px) {
    font-size: 30px !important;
  }
}

.fonts-nb {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 24px !important;
  font-weight: 400 !important;
  color: white;

  @media (min-width: 600px) {
    font-size: 30px !important;
  }

  @media (min-width: 1280px) {
    font-size: 34px !important;
  }
}


.fonts {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 24px !important;
  color: white;

  @media (min-width: 600px) {
    font-size: 30px !important;
  }

  @media (min-width: 1280px) {
    font-size: 34px !important;
  }
}

.fonts-black {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 24px !important;
  color: black;

  @media (min-width: 600px) {
    font-size: 30px !important;
  }

  @media (min-width: 1280px) {
    font-size: 34px !important;
  }
}

.fonts-white {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 24px !important;
  color: white;

  @media (min-width: 600px) {
    font-size: 30px !important;
  }

  @media (min-width: 1280px) {
    font-size: 34px !important;
  }
}

.fonts-small-black {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  color: white !important;

  @media (min-width: 600px) {
    font-size: 22px !important;
  }

  @media (min-width: 1280px) {
    font-size: 26px !important;
  }
}

.fonts-desc-black {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 14px !important;

  @media (min-width: 600px) {
    font-size: 18px !important;
  }

  @media (min-width: 1280px) {
    font-size: 22px !important;
  }
}

.fonts-small {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 20px !important;

  @media (min-width: 600px) {
    font-size: 26px !important;
  }

  @media (min-width: 1280px) {
    font-size: 30px !important;
  }
}

.font2-small {
  font-family: "Cormorant Garamond", serif !important;
  font-weight: 500 !important;
  font-size: 20px !important;

  @media (min-width: 600px) {
    font-size: 26px !important;
  }

  @media (min-width: 1280px) {
    font-size: 30px !important;
  }
}

.font2-head {
  font-family: "Cormorant Garamond", serif !important;
  font-weight: 600 !important;
  font-size: 30px !important;

  @media (min-width: 600px) {
    font-size: 38px !important;
  }

  @media (min-width: 1280px) {
    font-size: 51px !important;
  }
}

.font3-head {
  font-family: "Cormorant Garamond", serif !important;
  font-weight: 500 !important;
  font-size: 30px !important;
  font-style: italic !important;
  word-spacing: normal !important;
  line-height: 1 !important;


  @media (min-width: 600px) {
    font-size: 36px !important;
  }

  @media (min-width: 1280px) {
    font-size: 51px !important;
  }
}

.font4-head {
  font-family: "Cormorant Garamond", serif !important;
  font-weight: 500 !important;
  font-size: 30px !important;
  word-spacing: normal !important;
  line-height: 1 !important;


  @media (min-width: 600px) {
    font-size: 36px !important;
  }

  @media (min-width: 1280px) {
    font-size: 51px !important;
  }
}


.font2 {
  font-family: "Cormorant Garamond", serif !important;
  font-weight: 500 !important;
  font-size: 24px !important;

  @media (min-width: 600px) {
    font-size: 30px !important;
  }

  @media (min-width: 1280px) {
    font-size: 34px !important;
  }
}

.container {
  width: 100% !important;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 600px) {
    width: 100% !important;
  }

  @media (min-width: 1280px) {
    max-width: 1225px !important;
  }
}

.textVideo {
  position: absolute !important;
  bottom: 0 !important;
  margin-left: auto !important;
  margin-right: auto !important;
  width: 100vw !important;
}

.textPanel {
  margin-right: auto !important;
  padding-left: 320px !important;
  width: 100vw !important;
}

.textPanelMobile {
  margin-right: 0px !important;
  padding-left: 110px !important;
  width: 100vw !important;
}

.textPanelMobileXs {
  margin-right: 0px !important;
  padding-left: 0px !important;
  width: 100vw !important;
}

.videoMargins {
  margin-left: 0px !important;
  margin-right: 0px !important;

  @media (min-width: 1280px) {
    margin-left: 230px !important;
    margin-right: 230px !important;
  }
}

.videoMargins2 {
  margin-left: 20px !important;
  margin-right: 20px !important;

  @media (min-width: 1280px) {
    margin-left: 20px !important;
    margin-right: 20px !important;
  }
}

.divider {
  max-height: 2px !important;
  height: 2px !important;
  color: white !important;
  opacity: 0.9 !important;
  padding-bottom: 12px !important;
}

.dividerxs {
  max-height: 2px !important;
  height: 2px !important;
  color: white !important;
  opacity: 0.9 !important;
  padding-bottom: 6px !important;
}

.btn-wrap-text {
  max-width: 100% !important;
  display: inline-block !important;
  line-height: 1.1 !important;
}

.btn-wrap-text:hover {
  text-decoration: underline !important;
  cursor: pointer !important;
  text-decoration-thickness: 1px !important;
  text-underline-offset: 3px !important;
}

.fonts-xsmall {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 600 !important;
  font-size: 22px !important;
  word-spacing: normal !important;

  @media (min-width: 600px) {
    font-size: 22px !important;
  }

  @media (min-width: 1280px) {
    font-size: 22px !important;
  }
}

.fonts-xsmall2 {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 500 !important;
  font-size: 22px !important;
  word-spacing: normal !important;
  line-height: 1 !important;

  @media (min-width: 600px) {
    font-size: 22px !important;
  }

  @media (min-width: 1280px) {
    font-size: 22px !important;
  }
}

.fonts-xsmall3 {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 500 !important;
  font-size: 20px !important;
  word-spacing: normal !important;
  line-height: 1 !important;

  @media (min-width: 600px) {
    font-size: 22px !important;
  }

  @media (min-width: 1280px) {
    font-size: 22px !important;
  }
}

.fonts-xsmall-date {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  word-spacing: normal !important;
  line-height: 1.1 !important;

  @media (min-width: 600px) {
    font-size: 18px !important;
  }

  @media (min-width: 1280px) {
    font-size: 18px !important;
  }
}

.image-container:hover {
  cursor: pointer !important;
}

.image-container:hover .image-link {
  cursor: pointer !important;
}

.image-container:hover .btn-wrap-text {
  text-decoration: underline !important;
  cursor: pointer !important;
  text-decoration-thickness: 1px !important;
  text-underline-offset: 3px !important;
}

.page-top {
  margin-top: 0px !important;
  padding-top: 40px !important;
}

.page-bottom {
  padding-bottom: 30px !important;
}


.v-field--variant-filled .v-field__overlay {
  background-color: white !important;
}

.logo-modal.v-responsive__sizer {
  padding-bottom: 1px;
}

.results-font {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 28px !important;
  min-width: 100%;
  max-width: 100%;
}

.results-font-big {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 38px !important;
  min-width: 100%;
  max-width: 100%;
}


.v-text-field .v-label {
  color: white !important;
  font-size: 14px !important;
}

.v-label {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  min-width: 100%;
  max-width: 100%;
  color: black !important;
  opacity: 1 !important;

  @media (min-width: 600px) {
    font-size: 20px !important;
  }

  @media (min-width: 1280px) {
    font-size: 24px !important;
  }
}

.v-input--disabled .v-input__details {
  color: white !important;
  opacity: 1 !important;
}

.v-field--disabled {
  opacity: 1 !important;
}

.v-input--disabled .v-field--variant-filled .v-field__outline::before {
  opacity: 1 !important;
}

.v-input--error:not(.v-input--disabled) .v-input__details .v-messages {
  color: #e34234 !important;
}

.v-badge--inline .v-badge__badge {
  font-size: 18px !important;
  height: 28px !important;
}


.v-snackbar {
  z-index: 9999;
  /* Upewnij się, że snackbar jest na wierzchu */
}

.v-snackbar__wrapper {
  border-radius: 0px !important;
}

.fonts-black2 {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 20px !important;
  color: white !important;

}

.v-btn {
  text-transform: none !important;
  box-shadow: none !important;
}

.v-btn:hover>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

.v-btn[aria-haspopup=menu][aria-expanded=true]>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

.v-btn[aria-haspopup=menu][aria-expanded=true]:hover>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

.v-btn--disabled.v-btn--variant-elevated .v-btn__overlay {
  opacity: 1;
  background-color: #121212 !important;
}


input:-webkit-autofill,
input:-webkit-autofill:focus {
  transition: background-color 0s 600000s, color 0s 600000s !important;
}

.menu-btn-icon-border3.bg-primary {
  background-color: black !important;
}

.menu-btn-icon-border3 {
  color: white !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: bold !important;
  font-size: 20px !important;
  border: 1px solid black !important;
  box-shadow: none !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  transition: none !important;
  background-color: black !important;
}

.menu-btn-icon-border3:hover {
  color: black !important;
  border: 1px solid black !important;
  background-color: white !important;
  transition: none !important;
}

.menu-btn-icon-border3:hover .v-icon {
  color: black !important;
  transition: none !important;
}

.menu-btn-icon-border3:before {
  display: none !important;
}

.v-selection-control__input>.v-icon {
  border: 0px solid white !important;
  color: white !important;
  opacity: 1 !important;
}

.nomenu-btn-page {
  color: white;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 16px;
  transition: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-page.active,
.nomenu-btn-page:hover {
  color: white;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-page::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 27px;
  width: 100%;
  /* Spread the line over the text and icon */
  height: 1px;
  /* Line thickness */
  background-color: white;
  /* Color of the underline */
  opacity: 1;
  /* Initially hide the underline */
}

.nomenu-btn-page.active::before,
.nomenu-btn-page:hover::before {
  opacity: 0.3;
  /* Show the underline when hovering */
}
</style>
